import { LuneTheme, Select as LuneSelect } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import { FC, useState } from 'react'

import '@fontsource/space-mono'

import '@fontsource/space-mono/400.css'

const Select: FC<{ onChange: (v: '1' | '2' | '3') => void }> = ({ onChange }) => {
    const { palette, spacing } = LuneTheme
    const [value, setValue] = useState<string>('1')
    return (
        <Box
            sx={{
                position: 'absolute',
                left: '40px',
                top: '40px',
                gap: 3,
                width: '520px',
            }}
        >
            <LuneSelect
                menuElevation={0}
                menuSx={{
                    borderRadius: '32px',
                    border: `1px solid ${palette.Blue500} !important`,
                    marginTop: spacing(1),
                    minWidth: '520px !important',

                    '& .MuiTypography-root': {
                        color: `${palette.Blue500} !important`,
                        fontFamily: 'Space mono',
                    },
                    '.MuiList-root': {
                        padding: `${spacing(3)} 0`,
                    },
                    '& .MuiMenuItem-root': {
                        padding: `0 ${spacing(3)}`,
                        minHeight: '48px',
                        '&.Mui-selected': {
                            backgroundColor: `${palette.Blue50} !important`,
                        },
                    },

                    '& .MuiMenuItem-root.Mui-selected': {
                        backgroundColor: palette.Blue50,
                    },
                    '& .MuiMenuItem-root:hover': {
                        backgroundColor: palette.Blue50,
                    },
                    '& .MuiMenuItem-root.Mui-selected:hover': {
                        backgroundColor: palette.Blue50,
                    },
                }}
                sx={{
                    '& .MuiTypography-root': {
                        color: `${palette.Blue500} !important`,
                        fontFamily: 'Space mono',
                    },
                    '& .MuiSvgIcon-root': {
                        color: palette.Blue500,
                    },
                    padding: '0px 12px 0px 20px',
                    borderRadius: '40px',
                    border: `1px solid ${palette.Blue500} !important`,
                    backgroundColor: palette.White,
                    height: spacing(7),
                    color: palette.Blue500,
                    '&:hover, &:focus-within': {
                        backgroundColor: palette.Blue50,
                    },
                    '&:active': {
                        backgroundColor: palette.White,
                    },
                    width: '100%',
                }}
                items={[
                    { label: 'Asia to Mediterranean', value: '1' },
                    { label: 'Europe to North America', value: '2' },
                    { label: 'Intra-mediterranean', value: '3' },
                ]}
                value={value}
                onChange={(v) => {
                    setValue(v)
                    onChange(v as '1' | '2' | '3')
                }}
            />
        </Box>
    )
}

export default Select
